import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import ar from './locales/ar.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  ar: { translation: ar }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // Constrain the active language to a supported base code so an unsupported
    // browser locale falls back to 'en' (rather than leaving i18n.language as,
    // say, 'fr').
    supportedLngs: ['en', 'es', 'ar'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
      // Strip the region suffix from whatever the browser/localStorage reports
      // ('ar-SA' -> 'ar', 'es-MX' -> 'es', 'en-GB' -> 'en') BEFORE i18next adopts
      // it, so i18n.language is always exactly en/es/ar. Without this, a
      // region-tagged locale leaves i18n.language as 'ar-SA', which every
      // `i18n.language === 'ar'` check across the app (site-wide RTL, the
      // customer menu's display language) fails — so the menu would render in
      // English/LTR even though the rest of the site resolves to Arabic.
      convertDetectedLanguage: (lng) => (lng || '').split('-')[0]
    },
    react: {
      useSuspense: false
    }
  });

// Function to change language and update document direction
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('language', lng);
  // A deliberate pick (this helper backs the LanguageSwitcher) is remembered so the
  // per-restaurant default_language won't override it on the customer menu. The browser
  // auto-detect path never calls this, so it never sets the flag.
  try { localStorage.setItem('langChosen', '1'); } catch (_) {}

  // Update document direction for RTL languages
  const direction = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
};

// Initialize direction based on current language
const initDirection = () => {
  const currentLang = i18n.language || 'en';
  const direction = currentLang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = currentLang;
};

// Call on initial load
initDirection();

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
});

export default i18n;
